import { apiFetch } from './auth-service';

export const getGroupSessions = async (): Promise<any[]> => {
  return apiFetch.get<any[]>('/sessions');
};

export const getGroupSessionById = async (id: string): Promise<any> => {
  return apiFetch.get<any>(`/sessions/${id}`);
};

export const createGroupSession = async (data: {
  title: string;
  mentorId: string;
  participants: string[];
  scheduledAt: string;
  duration: number;
  meetLink?: string;
  agenda?: string;
}): Promise<any> => {
  return apiFetch.post<any>('/sessions', data);
};

export const deleteGroupSession = async (id: string): Promise<void> => {
  await apiFetch.delete(`/sessions/${id}`);
};

export const markAttendance = async (
  sessionId: string,
  attendees: { userId: string; status: string }[]
): Promise<any> => {
  return apiFetch.patch<any>(`/sessions/${sessionId}/attendance`, { attendees });
};

export const setSessionMeetLink = async (sessionId: string, meetLink: string): Promise<any> => {
  return apiFetch.patch<any>(`/sessions/${sessionId}/meet-link`, { meetLink });
};

export const getEligibleParticipants = async (): Promise<any[]> => {
  const r = await apiFetch.get<{ users: any[] }>('/users?userType=founder');
  return r.users ?? [];
};
